import { useState } from 'react'
import { Button } from '../../design'
import { META_APP_COPY } from './copy'

type CopyState = 'idle' | 'copied' | 'failed'

type CopyFieldProps = {
  label: string
  hint: string
  value: string
}

export const CopyField = ({ label, hint, value }: CopyFieldProps) => {
  const [state, setState] = useState<CopyState>('idle')

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(value)
      setState('copied')
    } catch {
      setState('failed')
    }
  }

  return (
    <div className="copy-field">
      <span className="copy-field-label">{label}</span>
      <code className="copy-field-value num">{value}</code>
      <div className="copy-field-actions">
        <Button aria-label={`${META_APP_COPY.copy}${label}`} onClick={() => void onCopy()}>
          {state === 'copied' ? META_APP_COPY.copied : META_APP_COPY.copy}
        </Button>
        {state === 'failed' ? (
          <span role="alert" className="text-tone tone-danger">
            {META_APP_COPY.copyFailed}
          </span>
        ) : null}
      </div>
      <p className="settings-hint measure">{hint}</p>
    </div>
  )
}
